import type { VentaVista } from '@barbones/shared';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { api, ErrorApi, mensajeError } from '@/api/cliente';
import { Button } from '@/components/ui/button';
import { Dialogo } from '@/components/ui/overlay';
import { SelectorCliente, type SeleccionCliente } from '../clientes/SelectorCliente';

function erroresDeApi(error: unknown): Record<string, string> {
  if (!(error instanceof ErrorApi) || !Array.isArray(error.details)) return {};
  return Object.fromEntries(
    (error.details as { path?: (string | number)[]; message: string }[]).map((d) => [(d.path ?? []).join('.'), d.message]),
  );
}

/** Toda venta de mostrador queda vinculada a un cliente: se busca o se registra antes de abrirla. */
export function NuevaVentaMostradorDialog({ onCreada, onCerrar }: { onCreada: (venta: VentaVista) => void; onCerrar: () => void }) {
  const [cliente, setCliente] = useState<SeleccionCliente>(null);
  const crear = useMutation({
    mutationFn: () =>
      api<VentaVista>('/ventas', {
        method: 'POST',
        body:
          cliente?.tipo === 'existente'
            ? { clienteId: cliente.cliente.id }
            : { clienteNuevo: { ...cliente!.datos, origenDetalle: cliente!.datos.origenDetalle || undefined } },
      }),
    onSuccess: (v) => onCreada(v),
  });
  const errores = erroresDeApi(crear.error);
  const completo =
    cliente?.tipo === 'existente' || (cliente?.tipo === 'nuevo' && !!cliente.datos.nombre.trim() && !!cliente.datos.telefono.trim() && !!cliente.datos.origen);

  return (
    <Dialogo
      abierto
      onCambiarAbierto={(v) => !v && onCerrar()}
      titulo="Venta de mostrador"
      descripcion="Busca al cliente o regístralo para iniciar la venta."
      pie={
        <>
          <Button variante="secundario" onClick={onCerrar}>
            Cancelar
          </Button>
          <Button onClick={() => crear.mutate()} cargando={crear.isPending} disabled={!completo}>
            Iniciar venta
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <SelectorCliente valor={cliente} onCambiar={setCliente} errores={errores} />
        {crear.error && !Object.keys(errores).length && (
          <p role="alert" className="text-[13px] text-destructive">
            {mensajeError(crear.error)}
          </p>
        )}
      </div>
    </Dialogo>
  );
}
